import type { FaireProductEntity } from "../../entity_types/product";

export const p_up6abefvkt: FaireProductEntity = {
  token: "p_up6abefvkt",
  type: "product",
  name: "GRATEFUL FOR YOU GREETING CARD",
  brandToken: "b_523b782c",
  brandName: "Alphabet Studios",
  imageUrl:
    "https://cdn.faire.com/fastly/54c914149f0a6e8f2b0d0e941727a0f918d1035ac56fa7286072549180468c23.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5f364146dd0decb4a09ffd6d0b4c52cc3515892e98a3086c54df1f8c205c1c76.jpeg",
    "https://cdn.faire.com/fastly/8a85a1b067c2e3ae59b6cb48e23d2e3bb27cc4c6199b77cb94a7ddf19fddb2db.jpeg",
  ],
  priceDollars: 2.95,
  description:
    '4.5" x 6.25" blank card. Comes with an envelope in a protective cellophane bag.\nHand designed and screen printed on 100% cotton rag archival gray paper in our studio in Bellingham, WA. Formerly Gold Teeth Brooklyn.',
  tags: [],
  msrpDollars: 5.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:55:12.327Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
